var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-packets-component"},[(_vm.integrationType === 'web')?_c('web-message-packets',{attrs:{"form-data":_vm.formData},on:{"previousTab":function($event){return _vm.$emit('previousTab')}}}):_c('cloud-message-packets',{attrs:{"form-data":_vm.formData},on:{"previousTab":function($event){return _vm.$emit('previousTab')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }